import { makeStyles } from '@mui/styles';
import { COLORS } from '../../constant/colors';

const useStyles = makeStyles({
  ordersSec: {
      padding: '50px 0px',
      paddingTop: "180px",
      "@media (max-width: 991px)": {
        paddingTop: "160px",
      },
      "@media (max-width: 500px)": {
        paddingTop: "140px",
      }
  },
  heading: {
      textAlign: 'center',
      marginBottom: 50,
      "@media (max-width: 500px)": {
        marginBottom: 30,
      }
  },
  loaderSec: {
    padding: '50px 0px',
    textAlign: 'center',
  },
  loader: {
      textAlign: 'center',
      width: 50,
      height: 50,
  },
  // Modern Order Card Styles
  ordersList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    maxWidth: '800px',
    margin: '0 auto',
    padding: '0 20px',
  },
  orderCard: {
    backgroundColor: COLORS.white,
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
    },
  },
  orderCardContent: {
    cursor: 'pointer',
    padding: '24px',
  },
  orderHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '20px',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      gap: '12px',
    },
  },
  orderInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  orderIdSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  orderIdLabel: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#666',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  orderIdValue: {
    fontSize: '18px',
    fontWeight: '600',
    color: COLORS.textPrimary,
  },
  orderDate: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    color: '#666',
    '& i': {
      fontSize: '14px',
    },
  },
  orderStatus: {
    display: 'flex',
    alignItems: 'center',
  },
  statusBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    borderRadius: '16px',
    fontSize: '12px',
    fontWeight: '500',
    '& i': {
      fontSize: '12px',
    },
  },
  // Order Status Styles
  statusDelivered: {
    backgroundColor: '#e8f5e8',
    color: '#2e7d32',
    '& i': {
      color: '#2e7d32',
    },
  },
  statusDispatched: {
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
    '& i': {
      color: '#1976d2',
    },
  },
  statusReadyToDispatch: {
    backgroundColor: '#f3e5f5',
    color: '#7b1fa2',
    '& i': {
      color: '#7b1fa2',
    },
  },
  statusProcessing: {
    backgroundColor: '#fff3e0',
    color: '#f57c00',
    '& i': {
      color: '#f57c00',
    },
  },
  statusConfirmed: {
    backgroundColor: '#e8f5e8',
    color: '#388e3c',
    '& i': {
      color: '#388e3c',
    },
  },
  statusCancelled: {
    backgroundColor: '#ffebee',
    color: '#d32f2f',
    '& i': {
      color: '#d32f2f',
    },
  },
  statusRefunded: {
    backgroundColor: '#fce4ec',
    color: '#c2185b',
    '& i': {
      color: '#c2185b',
    },
  },
  statusReturnInitiated: {
    backgroundColor: '#fff8e1',
    color: '#f9a825',
    '& i': {
      color: '#f9a825',
    },
  },
  statusReturnReceived: {
    backgroundColor: '#e0f2f1',
    color: '#00695c',
    '& i': {
      color: '#00695c',
    },
  },
  statusOnHold: {
    backgroundColor: '#f5f5f5',
    color: '#616161',
    '& i': {
      color: '#616161',
    },
  },
  statusPending: {
    backgroundColor: '#fff3e0',
    color: '#f57c00',
    '& i': {
      color: '#f57c00',
    },
  },
  orderBody: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '20px',
    borderTop: '1px solid #f0f0f0',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      gap: '16px',
      alignItems: 'flex-start',
    },
  },
  orderAmountSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  amountLabel: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#666',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  amountValue: {
    fontSize: '20px',
    fontWeight: '700',
    color: COLORS.primary,
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    '& i': {
      fontSize: '16px',
    },
  },
  orderActions: {
    display: 'flex',
    alignItems: 'center',
  },
  viewDetails: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '600',
    color: COLORS.primary,
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: COLORS.primary,
      color: COLORS.white,
    },
    '& i': {
      fontSize: '12px',
      transition: 'transform 0.3s ease',
    },
  },
  noOrders: {
    textAlign: 'center',
    padding: '60px 20px',
    fontSize: '18px',
    color: '#666',
    backgroundColor: COLORS.white,
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  },
  // Modern Modal Styles
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingBottom: '24px',
    borderBottom: '1px solid #f0f0f0',
    marginBottom: '24px',
  },
  modalTitle: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  modalHeading: {
    fontSize: '24px',
    fontWeight: '600',
    color: COLORS.textPrimary,
    margin: 0,
  },
  orderIdBadge: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  orderIdLabel: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#666',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  orderIdValue: {
    fontSize: '16px',
    fontWeight: '600',
    color: COLORS.primary,
  },
  closeButton: {
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease',
    borderRadius: '50%',
    cursor: 'pointer',
    backgroundColor: '#f8f9fa',
    '&:hover': {
      backgroundColor: '#e9ecef',
      '& i': {
        color: '#000'
      },
    },
    '& i': {
      fontSize: '16px',
      color: '#666',
    },
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    maxHeight: 'calc(100vh - 200px)',
    overflowY: 'auto',
  },
  itemsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: COLORS.textPrimary,
    margin: 0,
    paddingBottom: '12px',
    borderBottom: '2px solid #f0f0f0',
  },
  itemsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  productCard: {
    display: 'flex',
    gap: '16px',
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#e9ecef',
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    },
  },
  productImage: {
    width: '80px',
    height: '80px',
    borderRadius: '8px',
    overflow: 'hidden',
    flexShrink: 0,
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  productInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  productName: {
    fontSize: '16px',
    fontWeight: '600',
    color: COLORS.textPrimary,
    margin: 0,
    lineHeight: 1.4,
  },
  productDetails: {
    display: 'flex',
    gap: '16px',
    fontSize: '14px',
    color: '#666',
  },
  productSku: {
    fontWeight: '500',
  },
  productQuantity: {
    fontWeight: '500',
  },
  productPricing: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  priceRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  priceLabel: {
    fontSize: '14px',
    color: '#666',
    fontWeight: '500',
  },
  priceValue: {
    fontSize: '14px',
    fontWeight: '600',
    color: COLORS.textPrimary,
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    '& i': {
      fontSize: '12px',
    },
  },
  paymentSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  paymentCard: {
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  paymentRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&.total': {
      paddingTop: '12px',
      borderTop: '1px solid #e0e0e0',
      fontWeight: '600',
    },
  },
  paymentLabel: {
    fontSize: '14px',
    color: '#666',
    fontWeight: '500',
  },
  paymentValue: {
    fontSize: '14px',
    fontWeight: '600',
    color: COLORS.textPrimary,
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    '&.total': {
      fontSize: '16px',
      color: COLORS.primary,
    },
    '& i': {
      fontSize: '12px',
    },
  },
  discount: {
    color: '#28a745',
  },
  total: {
    fontWeight: '600',
    fontSize: '16px',
    color: COLORS.primary,
  },
  paymentDivider: {
    height: '1px',
    backgroundColor: '#e0e0e0',
    margin: '8px 0',
  },
  reorderButton: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #c0392b 100%)`,
    color: COLORS.white,
    border: 'none',
    padding: '14px 32px',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(169, 37, 60, 0.3)',
    },
    '& i': {
      fontSize: '14px',
    },
  }
})  

export default useStyles;